/* Qapary · aviso y panel de cookies sobre la Customer Privacy API de Shopify. Sin dependencias. */
(function () {
  'use strict';

  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const aviso = q('[data-cookies-aviso]');
  const panel = q('[data-cookies-panel]');
  if (!aviso || !panel) return;
  const form = q('[data-cookies-form]', panel);
  const raiz = document.documentElement;
  const OPCIONALES = ['preferences', 'analytics', 'marketing'];
  let api = null;
  let ultimoFoco = null;

  /* ---------- API de Shopify: se espera a que content_for_header deje lista loadFeatures ---------- */
  const esperarShopify = () => new Promise((resolve) => {
    let intentos = 0;
    const mirar = () => {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') return resolve(true);
      if (++intentos > 50) return resolve(false);
      setTimeout(mirar, 100);
    };
    mirar();
  });
  const cargarApi = async () => {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.setTrackingConsent === 'function') return cp;
    if (!(await esperarShopify())) return null;
    return new Promise((resolve) => {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          resolve(error ? null : (window.Shopify.customerPrivacy || null));
        });
      } catch (e) { resolve(null); }
    });
  };
  const actual = () => {
    try { return (api && api.currentVisitorConsent()) || {}; } catch (e) { return {}; }
  };
  // Hay elección cuando medición y publicidad tienen un sí o un no explícito. Cerrar o seguir navegando no cuenta.
  const hayEleccion = (c) => ['analytics', 'marketing'].every((k) => c[k] === 'yes' || c[k] === 'no');

  /* ---------- Franja inferior: no modal, flota sobre la página sin moverla ---------- */
  const caja = q('.cookies-aviso__caja', aviso);
  const medir = () => raiz.style.setProperty('--cookies-aviso-alto', `${aviso.hidden ? 0 : aviso.offsetHeight}px`);
  const observador = 'ResizeObserver' in window ? new ResizeObserver(medir) : null;
  const mostrarAviso = () => {
    aviso.hidden = false;
    raiz.classList.add('cookies-con-aviso');
    medir();
    if (observador) observador.observe(caja);
  };
  const ocultarAviso = () => {
    aviso.hidden = true;
    raiz.classList.remove('cookies-con-aviso');
    if (observador) observador.disconnect();
    medir();
  };

  /* ---------- Panel: diálogo modal, Tab da la vuelta adentro, Escape cierra y el foco vuelve ---------- */
  const pintar = () => {
    const c = actual();
    OPCIONALES.forEach((k) => { if (form.elements[k]) form.elements[k].checked = c[k] === 'yes'; });
  };
  const abrirPanel = (origen) => {
    ultimoFoco = origen || document.activeElement;
    pintar();
    if (typeof panel.showModal === 'function') panel.showModal(); else panel.setAttribute('open', '');
    const primero = q('input[type="checkbox"]', panel);
    if (primero) primero.focus();
  };
  const cerrarPanel = () => {
    if (panel.open && typeof panel.close === 'function') panel.close(); else panel.removeAttribute('open');
  };
  panel.addEventListener('close', () => {
    const volver = ultimoFoco && document.contains(ultimoFoco) && !ultimoFoco.closest('[hidden]') ? ultimoFoco : null;
    // Si la franja ya se fue (se guardó desde el panel), el foco cae en el contenido y no en el body.
    (volver || q('#contenido') || document.body).focus();
    ultimoFoco = null;
  });
  panel.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && typeof panel.showModal !== 'function') { e.preventDefault(); cerrarPanel(); return; }
    if (e.key !== 'Tab') return;
    const f = qa('a[href], button:not([disabled]), input:not([disabled])', panel).filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  // Un toque en el velo cierra igual que la X: sin elección guardada, la franja sigue ahí.
  panel.addEventListener('click', (e) => { if (e.target === panel) cerrarPanel(); });

  /* ---------- Guardar: sale_of_data sigue a Publicidad ---------- */
  const guardar = (eleccion) => new Promise((resolve, reject) => {
    if (!api) { reject(new Error('sin api')); return; }
    const datos = {
      preferences: !!eleccion.preferences,
      analytics: !!eleccion.analytics,
      marketing: !!eleccion.marketing,
      sale_of_data: !!eleccion.marketing,
    };
    try {
      api.setTrackingConsent(datos, (res) => { if (res && res.error) reject(res.error); else resolve(); });
    } catch (e) { reject(e); }
  });
  const decidir = async (eleccion, boton) => {
    if (boton) boton.classList.add('boton--cargando');
    if (!api) api = await cargarApi();
    try {
      await guardar(eleccion);
      ocultarAviso();
      cerrarPanel();
      if (window.qapary && window.qapary.toast) window.qapary.toast('Guardamos tu elección de cookies. Puedes cambiarla desde el pie de página.');
    } catch (e) {
      if (window.qapary && window.qapary.toast) window.qapary.toast('No pudimos guardar tu elección. Intenta de nuevo en unos segundos.', { tono: 'error' });
    } finally {
      if (boton) boton.classList.remove('boton--cargando');
    }
  };
  const todas = (valor) => ({ preferences: valor, analytics: valor, marketing: valor });

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cookies-aceptar], [data-cookies-rechazar], [data-cookies-configurar], [data-cookies-cerrar]');
    if (!b) return;
    if (b.hasAttribute('data-cookies-configurar')) { e.preventDefault(); abrirPanel(b); }
    else if (b.hasAttribute('data-cookies-cerrar')) cerrarPanel();
    else decidir(todas(b.hasAttribute('data-cookies-aceptar')), b);
  });
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const eleccion = {};
    OPCIONALES.forEach((k) => { eleccion[k] = !!(form.elements[k] && form.elements[k].checked); });
    decidir(eleccion, q('[data-cookies-guardar]', form));
  });

  // Si la elección cambia desde otra pestaña o desde el checkout, la franja se va sola.
  document.addEventListener('visitorConsentCollected', () => { if (hayEleccion(actual())) ocultarAviso(); });

  /* ---------- Arranque: la franja sale mientras no haya una elección explícita guardada ---------- */
  cargarApi().then((cp) => {
    api = cp;
    // Sin API (bloqueador o falla de red) igual se muestra: al elegir se reintenta cargarla.
    if (!api || !hayEleccion(actual())) mostrarAviso();
  });
})();
